// src/hooks/useDynamicScrollHeight.ts

import { useState, useEffect } from 'react';

/**
 * PrimeReact DataTable veya benzeri kaydırılabilir bileşenler için 
 * pencere boyutuna göre dinamik kaydırma yüksekliğini (scrollHeight) hesaplar.
 * * @param offsetHeight - Navbar, başlık, paddingler, footer gibi 
 * tablonun üstünde ve altında kalan sabit yükseklik (piksel).
 * @returns DataTable'a atanacak dinamik yükseklik string'i (örn: "500px").
 */
export const useDynamicScrollHeight = (offsetHeight: number = 260): string => {
  // Başlangıç değeri veya hesaplanmış piksel değeri
  const [scrollHeight, setScrollHeight] = useState('65vh'); 

  useEffect(() => {
    const updateScrollHeight = () => {
      // Pencere yüksekliğinden sabit ofseti çıkararak kullanılabilir alanı buluruz.
      const availableHeight = window.innerHeight - offsetHeight; 
      
      // Minimum 100 piksel olmasını garanti edebiliriz (isteğe bağlı)
      const calculatedHeight = Math.max(100, availableHeight);

      setScrollHeight(`${calculatedHeight}px`);
    };

    // Bileşen yüklendiğinde ve pencere boyutu değiştiğinde güncelle.
    updateScrollHeight();
    window.addEventListener('resize', updateScrollHeight);

    // Temizleme fonksiyonu: Bileşen kaldırıldığında dinleyiciyi kaldır.
    return () => {
      window.removeEventListener('resize', updateScrollHeight);
    };
  }, [offsetHeight]); // offsetHeight değişirse tekrar çalışır.

  return scrollHeight;
};